/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { ModalID, SidebarID } from "@/frameworks/core/commons";
import { useSidebarActions } from "@/frameworks/core/hooks";
import { Button, Divider, Image, Row, Typography, useModal } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import InstructMakeGroup from "@/assets/images/backgrounds/instruct_make_group.png";

import { CreateGroupForNewMember } from "./CreateGroupForNewMember";
import CreateGroupLayout from "./CreateGroupLayout";

const InstructCreateGroup = () => {
	const { hide, show } = useModal();
	const sidebarActions = useSidebarActions();

	const handleClose = () => {
		hide(ModalID.INSTRUCT_CREATE_GROUP);
		sidebarActions.show(SidebarID.Space);
	};

	const handleShowListGroup = () => {
		hide(ModalID.INSTRUCT_CREATE_GROUP);
		sidebarActions.hide(SidebarID.Meeting);
		sidebarActions.show(SidebarID.Space);
		sidebarActions.show(SidebarID.FindGroupSpace);
	};

	const handleCreateGroup = () => {
		hide(ModalID.INSTRUCT_CREATE_GROUP);
		show({
			id: ModalID.CREATE_GROUP_FOR_NEW_MEMBER,
			content: <CreateGroupForNewMember />
		});
	};

	return (
		<CreateGroupLayout handleClose={handleClose}>
			<Typography
				css={{
					fontWeight: "800",
					fontSize: "64px",
					marginBottom: "32px",
					lineHeight: "76px"
				}}
				typoColor="neutral_80_100"
			>
				{_T("그룹 만들기")}
			</Typography>

			<Image css={{ maxWidth: 536, maxHeight: 354 }} src={InstructMakeGroup} />
			<Typography
				css={{
					marginTop: 20,
					marginBottom: 12,
					whiteSpace: "pre-line"
				}}
				typoSize="Title1"
				typoColor="neutral_80_100"
			>
				{_T(
					"RfIce에서 다양한 그룹을 만들어 보세요. \n그룹은 사람들을 초대하여  함께 어울릴 수 있는  기본 모임 입니다.  \n그룹을 개설하여 나와 함께 스페이스를 만들 사용자들을 초대해 보세요."
				)}
			</Typography>
			<Row>
				<Button css={{ width: 160, height: 44, borderRadius: 32 }} filled="secondary" onClick={handleClose}>
					{_T("취소")}
				</Button>
				<Button
					css={{ width: 160, height: 44, borderRadius: 32, marginLeft: 12 }}
					filled="gradient"
					typoColor="neutral_00_100"
					onClick={handleCreateGroup}
				>
					{_T("그룹 만들기")}
				</Button>
			</Row>
			<Row css={{ width: 400, margin: "28px 0" }}>
				<Divider type="line" />
			</Row>
			<Typography typoSize="Title1" typoColor="neutral_80_100">
				{_T("혹시 그룹에 초대된 사용자인가요?")}
			</Typography>
			<Button css={{ width: 160, height: 44, borderRadius: 32, marginTop: 12 }} onClick={handleShowListGroup}>
				{_T("그룹 찾기")}
			</Button>
		</CreateGroupLayout>
	);
};

export default InstructCreateGroup;
